import { ScoreTrigger } from '@/entities/scoreTrigger/model';
import { ScoreTriggerEditable } from '@/ui/DTO';

export const scoreTriggerIntoSendable = (resource: ScoreTriggerEditable|null): ScoreTrigger|null => {
  return resource ? {
    operator: resource.operator,
    from: parseFloat(resource.from),
    to: parseFloat(resource.to),
  } : null;
};

export const scoreTriggerIntoEditable = (resource: ScoreTrigger|null): ScoreTriggerEditable|null => {
  return resource ? {
    operator: resource.operator,
    from: resource.from.toString(),
    to: resource.to.toString(),
  } : null;
};
